<template>
	<div class="VipRight">
		<div class="PubBox Boxs   ZAuto">
			 <div class="QuickNavigation">
				<div class="cone_left-title">
					<div class="title-sub">
						<el-row>
						  <el-button round @click="getzx">全部证件</el-button>
						    
						</el-row>
					</div>
					
				</div>
				 
			 
			 </div>
			 <div class="QuickNavigation">
				 <div class="imgbox">
					<div class="block" v-for="(item,index) in zxlist" :key="index" v-show="item.cid==3">
						
						<a :href="item.desc" target="_blank"><el-image
						  style="width: 250px; height: 250px"
						  :src="zurl+item.photopath"></el-image></a>
						  <p class="demonstration"><span class="uspan">{{ item.title }}</span>  
						   <el-link type="danger" :href="item.desc" target="_blank">立即查看</el-link></p>
					  </div>
				  </div>
			 </div>




		</div>


	</div>
</template>
<script>
	import {
		 GetInfoList,
		 GetOrderInfo,
		 GetInfoCate,
		 GetInfoDetails
		 
	} from "../../api/api";
	 
	export default {
		 
		data() {
			return {
				 zxlist:[],
				 zurl:"http://login.jianyanedu.cn"
			};
		},
		mounted() {
			 this.$nextTick(function () {
				 
				 this.getzx()
				 
			})
		 
		}, 
		methods: {
			getdd(){
				GetOrderInfo({})
				.then((res) => {
			 	if (res.code == 1) {
			 		 console.log(22222222);
			 		console.log(res);
			 		 
			 		 
			 		// _this.changeVideo(_this.currentSpecial.video_list[0]);
			 	 
			 			 
			 	} 
			 })
			},
			getzx(){
				 GetInfoList({})
				 .then((res) => {
					if (res.code == 1) {
						 console.log("GetInfoList");
						console.log(res);
						 this.zxlist=res.data.list
						 
						// _this.changeVideo(_this.currentSpecial.video_list[0]);
					 
							 
				}
				 })
				},
		 }
	};
</script>
<style lang="less" scoped>
	.nkclist{
		padding:0 50px;margin:15px 0 5px
	}
	.VipRight {
		width: 1030px;
		float: right;
	}

	.QuickNavigation {
		background: #fff;
		margin-bottom: 20px;
	}

	.title-sub {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111;
		position: relative;
		padding: 20px 0;
		padding-left: 35px;
	}
.imgbox{
	padding:50px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
}
.imgbox p{
	padding:10px 0;
	display: flex;
	justify-content: space-between;
	
	
}
.imgbox p .uspan{
	font-size: 18px;
	line-height: 36px;
	font-weight: bold;
	 
}
	// .title-sub:before {
	// 	position: absolute;
	// 	left: 26px;
	// 	top: 25px;
	// 	content: "";
	// 	width: 3px;
	// 	height: 21px;
	// 	background: #3477ff;
	// }

	.cone_left-title .title-sub {
		font-size: 20px;
	}

	.flex-align-items,
	.flex-items-justify-content {
		display: flex;
		align-items: center;
	}

	.QuickNavigation-list {
		text-align: center;
		cursor: pointer;
		margin: 0 25px;
	}

	.QuickNavigation-list .img {
		width: 45px;
		height: 45px;
		margin: 0 auto;
		display: block;
		margin-bottom: 10px;
		border-radius: 10px;
	}

	.right-content {
		padding: 20px;
		position: relative;
	}

	.QuickNavigation-list .title {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333;
		line-height: 24px;
		padding-bottom: 20px;
	}

	.card-carousel-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		// margin: 20px 0 40px;
		color: #666a73;
	}

	.card-carousel {
		display: flex;

		width: 100%;
	}

	.card-carousel--overflow-container {
		overflow: hidden;
	}

	.card-carousel--nav__left,
	.card-carousel--nav__right {
		display: inline-block;
		width: 15px;
		height: 15px;
		padding: 10px;
		box-sizing: border-box;
		border-top: 2px solid #42b883;
		border-right: 2px solid #42b883;
		cursor: pointer;
		margin: 0 10px;
		transition: transform 150ms linear;
	}

	.card-carousel--nav__left[disabled],
	.card-carousel--nav__right[disabled] {
		opacity: 0.2;
		border-color: black;
	}

	.card-carousel--nav__left {
		transform: rotate(-135deg);
	}

	.card-carousel--nav__left:active {
		transform: rotate(-135deg) scale(0.9);
	}

	.card-carousel--nav__right {
		transform: rotate(45deg);
	}

	.card-carousel--nav__right:active {
		transform: rotate(45deg) scale(0.9);
	}

	.card-carousel-cards {
		display: flex;
		transition: transform 150ms ease-out;
		transform: translatex(0px);
	}

	.card-carousel-cards .card-carousel--card {
		width: 220px;
		margin: 0 10px;
		cursor: pointer;
		// box-shadow: 0 4px 15px 0 rgb(124 125 128 / 6%), 0 2px 2px 0 rgb(40 44 53 / 8%);
		background-color: #fff;
		border-radius: 4px;
		z-index: 3;
		margin-bottom: 2px;
	}

	.card-carousel-cards .card-carousel--card:first-child {
		margin-left: 0;
	}

	.card-carousel-cards .card-carousel--card:last-child {
		margin-right: 0;
	}

	.card-carousel-cards .card-carousel--card--footer {
		border-top: 0;
		padding: 7px 15px;
		height: 68px;
	}

	.card-carousel-cards .card-carousel--card--footer p {
		padding: 15px 0;
		text-align: center;
		font-size: 19px;
		font-weight: 500;
		color: #fff;
		user-select: none;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
		font-size: 12px;
		font-weight: 300;
		padding: 6px;
		background: rgba(40, 44, 53, 0.06);
		display: inline-block;
		position: relative;
		margin-left: 4px;
		color: #666a73;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):before {
		content: "";
		float: left;
		position: absolute;
		top: 0;
		left: -12px;
		width: 0;
		height: 0;
		border-color: transparent rgba(40, 44, 53, 0.06) transparent transparent;
		border-style: solid;
		border-width: 12px 12px 12px 0;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):after {
		content: "";
		position: absolute;
		top: 10px;
		left: -1px;
		float: left;
		width: 4px;
		height: 4px;
		border-radius: 2px;
		background: white;
		box-shadow: -0px -0px 0px #004977;
	}

	.bg_q {
		background: #71c8cf;
		    box-shadow: 4px 1px 8px 0 rgb(217 213 213 / 74%);
		border-radius: 4px;
		height: 80px;
		overflow: hidden;
	}
	.tabBody{
		display: flex;
		    align-items: center;
		    justify-content: center;
		    color: #555;
		    font-size: 18px;
		    background: #fff;
		    flex-wrap: wrap;
		    padding: 0 24px;
	}
	.QuickNavigation .tabBody{
		width: 574px;
		    margin: 0 auto;
		    border-bottom: 1px solid #e6e6e6;
	 
	}
	.tabItem{
		margin: 15px 70px 0 70px;
		    padding-bottom: 18px;
		    cursor: pointer;
		    position: relative;
	}
	.tabActiveItem{
		color: #2d83f3;
		    font-weight: 700;
	}
	.cpage-tabitem-line{
		width: 100%;
		    height: 2px;
		    position: absolute;
		    bottom: 0;
		    right: 0;
		    background-color: #2d83f3;
	}
</style>
